import {styled, Typography} from '@mui/material';
import {StyledTypographyProps} from './types';

const StyledTypography = styled(Typography, {
	shouldForwardProp: prop => prop !== 'isLaptop' && prop !== 'isBemobiFlow',
})<StyledTypographyProps>(({theme, isLaptop, isBemobiFlow}) => ({
	fontSize: isBemobiFlow ? '0.875rem' : '1rem',
	color: theme.colors.light.primary.main,
	fontWeight: 600,
	cursor: 'pointer',
	...(isLaptop
		? {
				marginTop: '16px',
				textAlign: 'right',
			}
		: null),
}));

const StyledSucessTyphography = styled(Typography)`
	color: ${({theme}) => theme.colors.light.text.primary};
	font-size: 12px;
`;

const StyledLink = styled(Typography)`
	color: ${({theme}) => theme.colors.light.primary.main};
	text-decoration: underline;
	cursor: pointer;
	margin-left: 2px;
`;

export {StyledTypography, StyledSucessTyphography, StyledLink};
